// src/utils/setFavicon.js
//
// Dynamically sets the browser tab favicon by replacing any existing
// <link rel="icon"> elements. The backend serves tenant-specific favicons
// at /api/v1/tenants/{tenant_id}/favicon with a variable Content-Type
// (svg/png/webp/ico) — do NOT set a type attribute on the <link>.
//
// See docs/be-integration/tenant-specific-logo-from-be.md §5.2 and §6.8.

/**
 * Remove every existing <link rel="icon"> / <link rel="shortcut icon">
 * from <head>, then append a fresh one pointing at `url`.
 *
 * Idempotent: safe to call multiple times (e.g. under React StrictMode
 * double-fire in development).
 *
 * @param {string} url - Absolute URL to the favicon image. No type
 *                       attribute is set, so the browser sniffs the MIME.
 */
export function setFavicon(url) {
  if (!url) return;
  clearFavicon();
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = url;
  document.head.appendChild(link);
}

/**
 * Remove every existing <link rel="icon"> / <link rel="shortcut icon">
 * element from <head>. Called on logout / AppShell unmount to revert
 * the tab icon to the browser default (there is no bundled FE favicon).
 */
export function clearFavicon() {
  const selectors = 'link[rel="icon"], link[rel="shortcut icon"]';
  document
    .querySelectorAll(selectors)
    .forEach((el) => el.remove());
}
